
export const solv3dPrimary = '#162031';
export const solv3dSecondary ='#DD0C29';

export const mosaicPrimary = '#A31C2E';
export const mosaicSecondary ='#33281F';